import * as React from 'react';

import type {DeltaMood, DeltaDirection} from 'nutshell-core/types';

import {DeltaArrow} from 'shells/delta-arrow/delta-arrow';
import {Body} from 'shells/typography/body';

import styles from './activity-table-quota-visual-delta.module.css';

type ActivityTableQuotaVisualDeltaProps = {
    previousTotal: number;
    currentTotal: number;
};

export const ActivityTableQuotaVisualDelta = ({
    previousTotal,
    currentTotal,
}: ActivityTableQuotaVisualDeltaProps) => {
    const increase = currentTotal - previousTotal;
    const percentDiff = Math.round((increase / previousTotal) * 100);

    let deltaMood: DeltaMood = 'neutral';
    let deltaDirection: DeltaDirection = 'neutral';

    if (percentDiff > 0) {
        deltaMood = 'positive';
        deltaDirection = 'up';
    } else if (percentDiff < 0) {
        deltaMood = 'negative';
        deltaDirection = 'down';
    }

    const percentDiffText =
        percentDiff !== 0 && !Number.isNaN(percentDiff) && percentDiff !== Infinity
            ? `${Math.abs(percentDiff)}%`
            : '';

    return (
        <div className={styles.container}>
            <Body
                size={NutClientConfig.hasActivityReportExpansionFF ? 'normal' : 'large'}
                color='dark'
            >
                {percentDiffText}
            </Body>
            <DeltaArrow
                size={NutClientConfig.hasActivityReportExpansionFF ? 'tiny' : 'small'}
                deltaMood={deltaMood}
                deltaDirection={deltaDirection}
            />
        </div>
    );
};
